import { type ReactNode } from 'react'
import style from '../style/components/checkout-field.module.scss'

interface InputFieldProps {
  type: 'input'
  placeholder: string
  isRequired: boolean
  displayName: string
  label?: ReactNode
  name: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  value: string
  isError: boolean
  errorMessage: string
}

interface TextAreaFieldProps {
  type: 'textarea'
  placeholder: string
  isRequired: boolean
  displayName: string
  name: string
  label?: ReactNode
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  value: string
  isError: boolean
  errorMessage: string
}

interface SelectFieldProps {
  type: 'select'
  options: { key: string, value: string, display?: string }[]
  isRequired: boolean
  displayName: string
  name: string
  placeholder?: string
  label?: ReactNode
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
  value: string
  isError: boolean
  errorMessage: string
}

type FieldProps = InputFieldProps | TextAreaFieldProps | SelectFieldProps

const CheckoutField = (props: FieldProps) => {
  return (
    <div className={style.wrapper}>
      <label className={style.label} htmlFor={props.displayName}>
        {props?.label ?? props.displayName}
      </label>
      {props.type === 'input' && props.name !== 'billing_address_first_name' && (
        <input
          className={style.input + `${props.isError ? ` ${style.error}` : ''}`}
          type="text"
          placeholder={props.placeholder}
          name={props.name}
          value={props.value}
          onChange={props.onChange}
        />
      )}
      {props.type === 'input' && props.name === 'billing_address_first_name' && (
        <input
          className={style.input + `${props.isError ? ` ${style.error}` : ''}`}
          type="text"
          placeholder={props.placeholder}
          name={props.name}
          value={props.value}
          onChange={props.onChange}
          maxLength={30}
        />
      )}
      {props.type === 'textarea' && (
        <textarea
          className={style.textarea + `${props.isError ? ` ${style.error}` : ''}`}
          placeholder={props.placeholder}
          name={props.name}
          value={props.value}
          onChange={props.onChange}
        />
      )}
      {props.type === 'select' && (
        <select
          className={style.select + `${props.isError ? ` ${style.error}` : ''}`}
          name={props.name}
          value={props.value}
          onChange={props.onChange}
        >
          {props.placeholder && (
            <option value="" disabled={true}>
              {props.placeholder}
            </option>
          )}

          {props.options.map((option, index) => (
            <option key={index} value={option.key}>
              {option.display || option.value}
            </option>
          ))}
        </select>
      )}
      {props.isError && (
        <div className={`error-message ${style.error}`}>
          {props.errorMessage}
        </div>
      )}
    </div>
  )
}

export default CheckoutField
